module.exports = __webpack_public_path__ + "img/video_leader.71b426d2.png";